import React from 'react';

const styles = {
  footer: {
    marginTop: 'auto',
    padding: '20px 32px 28px',
    borderTop: '1px solid var(--border)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 10,
    background: 'var(--bg-card)',
  },
  label: {
    fontFamily: 'var(--font-mono)',
    fontSize: 10,
    letterSpacing: '0.14em',
    textTransform: 'uppercase',
    color: 'var(--text-tertiary)',
  },
  logo: {
    height: 36,
    width: 'auto',
    maxWidth: 'min(260px, 75vw)',
    objectFit: 'contain',
    display: 'block',
  },
};

export default function PageFooter() {
  return (
    <footer style={styles.footer}>
      <div style={styles.label}>Developed By</div>
      <img
        src={`${process.env.PUBLIC_URL}/pm-logo.webp`}
        alt="Par Marketing"
        style={styles.logo}
      />
    </footer>
  );
}
